const API = process.env.REACT_APP_BACKEND_URL;

export function apiMessage(detail) {
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(x => x.msg).join(' · ');
  return detail?.message || 'No se pudo completar la operación.';
}

export async function channelRequest(path, { body, method = 'GET', signal } = {}) {
  if (!API) throw new Error('Falta configurar la dirección del servidor.');
  const response = await fetch(`${API}/api${path}`, {
    method, signal,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  let data;
  try { data = await response.json(); }
  catch { throw new Error('El servidor no devolvió una respuesta válida. Reintentá sin volver a crear el cliente.'); }
  if (!response.ok) {
    const error = new Error(apiMessage(data.detail));
    error.status = response.status;
    error.preflight = data.detail?.preflight;
    throw error;
  }
  return data;
}

export const FEATURE_LABELS = { receipts: 'Comprobantes', alerts: 'Alertas', reminders: 'Recordatorios', statements: 'Estados de cuenta', flyers: 'Flyers' };
export const CHANNEL_LABELS = { whatsapp: 'WhatsApp', telegram: 'Telegram' };
export const STATE_LABELS = { unconfigured: 'Sin configurar', legacy: 'Configuración anterior', ready: 'Configurado', draft: 'Pendiente de activar', pending: 'Guardado pendiente' };
export const toInput = profile => {
  if (!profile || !Number.isInteger(profile.revision)) throw new Error('No se pudo leer la configuración guardada. Recargá antes de editar.');
  const normalize = name => {
    const channel = profile[name];
    if (!channel || typeof channel.enabled !== 'boolean' || !channel.features || !channel.flyer_schedule) throw new Error('La configuración recibida está incompleta. Recargá antes de editar.');
    return { ...channel, group_id: String(channel.group_id || ''), group_name: String(channel.group_name || ''),
      authorized_sender_ids: Array.isArray(channel.authorized_sender_ids) ? channel.authorized_sender_ids.map(String) : [],
      financial_sender_ids: Array.isArray(channel.financial_sender_ids) ? channel.financial_sender_ids.map(String) : [] };
  };
  return { revision: profile.revision, mode: 'draft', primary_outgoing: profile.primary_outgoing || null, whatsapp: normalize('whatsapp'), telegram: normalize('telegram') };
};

export const loadUserDirectory = async () => {
  const [carteras, clientes, auditores] = await Promise.all([
    channelRequest('/carteras'), channelRequest('/clientes'), channelRequest('/auditores').catch(() => [])
  ]);
  if (!Array.isArray(carteras) || !Array.isArray(clientes)) throw new Error('No se pudieron cargar los clientes y sus carteras.');
  return { carteras, clientes, auditores: Array.isArray(auditores) ? auditores : [] };
};